import * as React from 'react';

export interface OrderContextState {
  register: (name: string) => void;
  getOrder: (name: string) => number;
  updateOrder: (name: string, newIndex: number) => void;
  order: string[];
}

export const OrderContext = React.createContext<OrderContextState>({
  register: () => {
    console.error('noContextFound');
  },
  getOrder: () => {
    console.error('noContextFound');
    return 0;
  },
  updateOrder: () => {
    console.error('noContextFound');
  },
  order: [],
});
